import styled from 'styled-components'

const Status = styled.div`
  display: inline-block;
  color: #404040;
  font-family: 'Gotham-Medium';
  font-size: 16px;
`

export default Status



// WEBPACK FOOTER //
// ./src/lib/typography/Status.jsx